// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
//import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import Flickity from "flickity-fullscreen";
// import FlickityFade from "flickity-fade";
// import FlickityAsNavFor from "flickity-as-nav-for";

import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar.js';
import FarloUiWhatsOnCalendar from './vendors/farlo-ui-whats-on-calendar.js';
import FarloUiAccessibleCalendar from './vendors/farlo-ui-accessible-performances.js';
// import { anchorDropdown } from './vendors/anchor-jump.js';


// Import Footer Components
import { mapLoader } from './components/footer/mapLoader.js';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/faqs.js';
import { navigation, navicon, searchIcon } from './components/footer/navigation.js';
import { ticker } from './components/footer/ticker.js';
import { formDates, restrictDatepicker } from './components/footer/formDates.js';
import { handleNavigation } from './components/footer/handleNavigation.js';
import { expand } from './components/footer/expand.js';
import { genreFilter } from './components/footer/genreFilter.js';
//import { draggableSlider } from './components/footer/draggableSlider.js';
import { particles } from './components/footer/particles.js';
import { newsFilter, filterPosts } from './components/footer/newsFilter.js';
import { showContents } from './components/footer/showContents.js';
import { careersExpand } from './components/footer/careersExpand.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { featuredCarouselv2 } from './components/footer/featuredCarouselv2.js';
import { scrollOffset } from './components/footer/scrollOffset.js';
import { keyDetails } from './components/footer/keyDetails.js';
import { emergencyBanner } from './components/footer/emergencyBanner.js';
import { popupDisplay } from './components/footer/popupDisplay.js';
import { secondaryFlickity } from './components/footer/flickity-gallery.js';
import { eventReadMore } from './components/footer/eventReadMore.js';
import './components/footer/personalisation.js';


const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

((document, window, history) => {
    const pushState = history.pushState;
    history.pushState = function (state) {
        if (typeof history.onpushstate === 'function') {
            history.onpushstate({ state });
        }
        return pushState.apply(history, arguments);
    };

    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.site-navigation__navicon')) navicon();
        if (document.querySelector('.site-navigation__search')) searchIcon();
        if (document.querySelector('.site-event-details__contents--show-more')) showContents();
        if (document.querySelector('.site-masthead__ticker')) ticker();
        if (document.querySelector('.site-header')) addScrolledClass();
        if (document.querySelector('.emergency-banner')) emergencyBanner();
        if (document.querySelector('.site-popup')) popupDisplay();
        if (document.querySelector('.farlo-whats-on__filters-categories__list-item-link')) genreFilter();
        document.querySelectorAll('#menu-primary-menu > .menu-item > a').forEach(_item => {
            _item.addEventListener('click', () => {
                document.querySelectorAll('.site-navigation__menu-item--active').forEach(_active => {
                    _active.classList.remove('site-navigation__menu-item--active');
                });
            });
        });

        if (document.querySelector('.site-navigation__sub-menu')) {
            document.querySelectorAll('.site-navigation__sub-menu').forEach(_sel => navigation(_sel));
        }

        if (document.querySelector('.access-link')) scrollOffset('.access-link', 130);

        document.querySelectorAll('[data-ui="carousel"]').forEach(el => featuredCarouselv2(el));
        if (document.querySelector('.menu-item-has-children')) handleNavigation();
        if (document.querySelector('.site-event-details__secondary-description')) expand();
        if (document.querySelector('#input_1_9')) formDates();
        if (document.querySelector('.site-page__events-right-section-button')) keyDetails();
        if (document.querySelector('.event-read-more-toggle')) eventReadMore();

        if (document.querySelector('.farlo-ui-crm--inline')) {
            document.querySelectorAll('[farlo-ui="crm"]').forEach(_sel => farloUiCrmSignup(_sel));
        }
        if (document.querySelector('.farlo-ui-crm__toggle')) {
            document.querySelectorAll('.farlo-ui-crm__toggle').forEach(_sel => {
                _sel.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    farloUiCrmSignup(e);
                });
            });
        }

        if (document.querySelector('.location-filter')) {
            filterPosts();
            newsFilter();
        }
        if (document.querySelector('.rank-math-list-item')) {
            document.querySelectorAll('.rank-math-question').forEach(_el => {
                _el.dataset.toggled = '0';
                _el.addEventListener('click', () => toggleFAQ(_el));
            });
        }
        if (document.querySelector('.farlo-ui-animated')) {
            document.querySelectorAll('.farlo-ui-animated').forEach(_sel => elementInView(_sel));
        }
        if (document.querySelector('.careers__list-item')) careersExpand();
        if (document.querySelector('[farlo-ui="calendar"]')) {
            document.querySelectorAll('[farlo-ui="calendar"]').forEach(_sel => new FarloUiTicketCalendar(_sel));
        }
        if (document.querySelector('[farlo-ui="whats-on-calendar"]')) {
            document.querySelectorAll('[farlo-ui="whats-on-calendar"]').forEach(_sel => new FarloUiWhatsOnCalendar(_sel));
        }
        if (document.querySelector('[farlo-ui="accessible-calendar"]')) {
            document.querySelectorAll('[farlo-ui="accessible-calendar"]').forEach(_sel => new FarloUiAccessibleCalendar(_sel));
        }
        if (document.querySelector('form')) {
            document.querySelector('form').querySelectorAll('select').forEach(_sel => new FarloUiSelectBox(_sel));
        }

        if (document.querySelector('.farlo-ui-lightbox__toggle')) {
            document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach(_sel => {
                new FarloUiLightbox(_sel);
            });
        }
        if (document.querySelector('.site-anchor-jump__toggle')) window.anchorDropdown();


        function enableRecaptcha() {
            const rec = document.querySelector('[data-recaptcha]');
            if (rec && !rec.src) rec.src = rec.dataset.src;
        }

        const customSelectors = ['.newsletter-lightbox', '.groups-lightbox', '.access-lightbox', '.contact-lightbox', '.access-guideline-lightbox'];
        customSelectors.forEach(selector => {
            const box = document.querySelector(selector);
            if (!box) return;
            const contentInner = box.querySelector('.farlo-ui-lightbox__content-inner');
            const closeBtn = box.querySelector('.farlo-ui-lightbox__close');
            const backdrop = box.querySelector('.farlo-ui-lightbox__backdrop');
            closeBtn && closeBtn.addEventListener('click', () => box.classList.remove('farlo-ui-lightbox--active'));
            backdrop && backdrop.addEventListener('click', () => box.classList.remove('farlo-ui-lightbox--active'));
            box.addEventListener('click', e => {
                if (box.classList.contains('farlo-ui-lightbox--active') && contentInner && !contentInner.contains(e.target)) {
                    box.classList.remove('farlo-ui-lightbox--active');
                }
            });
        });
        // Close custom overlays on ESC key
        window.addEventListener('keydown', e => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                customSelectors.forEach(selector => {
                    const b = document.querySelector(selector);
                    if (b && b.classList.contains('farlo-ui-lightbox--active')) {
                        b.classList.remove('farlo-ui-lightbox--active');
                    }
                });
            }
        });

        // CRM overlay trigger
        document.querySelectorAll("[data-toggle='crm-overlay']").forEach(_sel => {
            _sel.addEventListener('click', () => {
                const lightbox = document.querySelector('.newsletter-lightbox');
                if (!lightbox) return;
                lightbox.querySelector('[data-prompt]').textContent = _sel.dataset.prompt;
                lightbox.querySelector('[data-subtitle]').textContent = _sel.dataset.subtitle;
                if (_sel.dataset.product) {
                    lightbox.querySelector('#input_3_8').value = _sel.dataset.product;
                }
                if (_sel.dataset.img) {
                    lightbox.querySelector('[data-img]').innerHTML =
                        `<img style="margin-top:32px;margin-bottom:16px;" class="has-border-radius-1" src="${_sel.dataset.img}" alt="${_sel.dataset.prompt}" />`;
                }
                lightbox.classList.add('farlo-ui-lightbox--active');
                enableRecaptcha();
            });
        });

        // Groups overlay trigger
        document.querySelectorAll("[data-toggle='groups-overlay']").forEach(btn => {
            btn.addEventListener('click', () => {
                const lightbox = document.querySelector('.groups-lightbox');
                if (!lightbox) return;
                lightbox.querySelector('[data-prompt]').textContent = btn.dataset.prompt;
                lightbox.querySelector('[data-subtitle]').textContent = btn.dataset.subtitle;
                if (btn.dataset.product) {
                    lightbox.querySelector('#input_4_16').value = btn.dataset.product;
                    lightbox.querySelector('#input_4_15').value = btn.dataset.type;
                }
                if (btn.dataset.img) {
                    lightbox.querySelector('[data-img]').innerHTML =
                        `<img style="margin-top:32px;margin-bottom:16px;" class="has-border-radius-1" src="${btn.dataset.img}" alt="${btn.dataset.prompt}" />`;
                }
                restrictDatepicker(lightbox.querySelector('.restrict-dates input'), btn.dataset.start, btn.dataset.end);
                lightbox.classList.add('farlo-ui-lightbox--active');
                enableRecaptcha();
            });
        });

        document.querySelectorAll("[data-toggle='education-overlay']").forEach(btn => {
            btn.addEventListener('click', () => {
                const lightbox = document.querySelector('.education-lightbox');
                if (!lightbox) return;
                lightbox.querySelector('[data-prompt]').textContent = btn.dataset.prompt;
                lightbox.querySelector('[data-subtitle]').textContent = btn.dataset.subtitle;
                if (btn.dataset.product) {
                    lightbox.querySelector('#input_9_16').value = btn.dataset.product;
                    lightbox.querySelector('#input_9_15').value = btn.dataset.type;
                }
                if (btn.dataset.img) {
                    lightbox.querySelector('[data-img]').innerHTML =
                        `<img style="margin-top:32px;margin-bottom:16px;" class="has-border-radius-1" src="${btn.dataset.img}" alt="${btn.dataset.prompt}" />`;
                }
                restrictDatepicker(lightbox.querySelector('.restrict-dates input'), btn.dataset.start, btn.dataset.end);
                lightbox.classList.add('farlo-ui-lightbox--active');
                enableRecaptcha();
            });
        });

        // Access overlay trigger
        document.querySelectorAll("[data-toggle='access-overlay']").forEach(btn => {
            btn.addEventListener('click', () => {
                const lightbox = document.querySelector('.access-lightbox');
                if (!lightbox) return;
                lightbox.querySelector('[data-prompt]').textContent = btn.dataset.prompt;
                lightbox.querySelector('[data-subtitle]').textContent = btn.dataset.subtitle;
                if (btn.dataset.product) {
                    lightbox.querySelector('#input_7_6').value = btn.dataset.product;
                }
                if (btn.dataset.img) {
                    lightbox.querySelector('[data-img]').innerHTML =
                        `<img style="margin-top:32px;margin-bottom:16px;" class="has-border-radius-1" src="${btn.dataset.img}" alt="${btn.dataset.prompt}" />`;
                }
                restrictDatepicker(lightbox.querySelector('.restrict-dates input'), btn.dataset.start, btn.dataset.end);
                lightbox.classList.add('farlo-ui-lightbox--active');
                enableRecaptcha();
            });
        });

        document.querySelectorAll("[data-toggle='contact-overlay']").forEach(btn => {
            btn.addEventListener('click', () => {
                const lightbox = document.querySelector('.contact-lightbox');
                if (!lightbox) return;
                lightbox.querySelector('[data-prompt]').textContent = btn.dataset.prompt;
                lightbox.querySelector('[data-subtitle]').textContent = btn.dataset.subtitle;
                lightbox.classList.add('farlo-ui-lightbox--active');
                enableRecaptcha();
            });
        });


        // Access guidelines overlay trigger
        document.querySelectorAll("[data-toggle='access-guidelines']").forEach(btn => {
            btn.addEventListener('click', () => {
                const lightbox = document.querySelector('.access-guideline-lightbox');
                if (!lightbox) return;
                lightbox.classList.add('farlo-ui-lightbox--active');
            });
        });

        // YouTube video popups via lightbox
        // document.querySelectorAll('.has-media-video').forEach(el => {
        //     new FarloUiLightbox(el, {
        //         content() {
        //             const match = (el.dataset.video.match(youTubeRegex) || []);
        //             const id = match[1];
        //             return id
        //                 ? `<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`
        //                 : '';
        //         }
        //     });
        // });


        document.querySelectorAll("[data-video]").forEach((target) => {
            target.addEventListener("click", () => {
                if (!target.closest(".site-photogallery__media")) {
                    const match = target.dataset.video.match(youTubeRegex);
                    if (!match) return;

                    const iframe = document.createElement('iframe');
                    iframe.className = 'farlo-ui-lightbox__inner-content-iframe';
                    iframe.src = `https://www.youtube-nocookie.com/embed/${match[1]}?autoplay=1&rel=0`;
                    iframe.frameBorder = '0';
                    iframe.allow = 'autoplay; encrypted-media';
                    iframe.allowFullscreen = true;

                    const videoWrapper = document.createElement('div');
                    videoWrapper.className = 'has-media-video__active';
                    videoWrapper.appendChild(iframe);

                    target.appendChild(videoWrapper);
                }
            });
        });

        document.addEventListener("click", (e) => {

            if (e.target.matches(".farlo-ui-lightbox__close-button, .farlo-ui-lightbox__overlay, .flickity-fullscreen-button-exit")) {
                document.querySelectorAll(".has-media-video__active").forEach((wrapper) => {
                    const iframe = wrapper.querySelector(".farlo-ui-lightbox__inner-content-iframe");
                    if (iframe) {
                        iframe.src = "";
                        iframe.remove();
                    }
                    wrapper.remove();
                });
            }
        });


        function setSectionOpen(headerEl, open) {
            const content = headerEl?.nextElementSibling;
            if (!content) return;

            headerEl.classList.toggle("site-collapsible-section__open", !!open);

            content.style.setProperty(
                '--section-height',
                open ? content.scrollHeight : 0
            );

            headerEl.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        function getHeaderForHashTarget(target) {
            if (!target) return null;

            if (target.matches('section.site-collapsible-section')) {
                return target.querySelector('.site-collapsible-section__header');
            }

            if (target.classList?.contains('site-collapsible-section__header')) {
                return target;
            }

            const content = target.closest('.site-collapsible-section__content');
            if (content && content.previousElementSibling?.classList?.contains('site-collapsible-section__header')) {
                return content.previousElementSibling;
            }

            return null;
        }

        function openForHash(hash) {
            if (!hash) return;
            const id = decodeURIComponent(hash.replace(/^#/, ''));
            const target = document.getElementById(id);
            if (!target) return;

            let header = null;

            if (target.matches('section.site-collapsible-section')) {
                header = target.querySelector('.site-collapsible-section__header');
            }

            if (!header && target.classList.contains('site-collapsible-section__header')) {
                header = target;
            }

            if (!header) {
                const content = target.closest('.site-collapsible-section__content');
                if (content && content.previousElementSibling?.classList.contains('site-collapsible-section__header')) {
                    header = content.previousElementSibling;
                }
            }

            if (!header) return;

            const content = header.nextElementSibling;
            header.classList.add('site-collapsible-section__open');
            content.style.setProperty('--section-height', content.scrollHeight + 'px');
            header.setAttribute('aria-expanded', 'true');

            setTimeout(() => {
                content.style.setProperty('--section-height', content.scrollHeight + 'px');
            }, 300);

            const y = header.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }

        window.addEventListener('DOMContentLoaded', () => openForHash(location.hash));
        window.addEventListener('hashchange', () => openForHash(location.hash));


        document.querySelectorAll(".site-collapsible-section__header").forEach(header => {
            header.setAttribute('aria-controls', header.nextElementSibling?.id || '');
            header.setAttribute('aria-expanded', header.classList.contains('site-collapsible-section__open') ? 'true' : 'false');
            header.addEventListener("click", () => {
                const isOpen = header.classList.contains("site-collapsible-section__open");
                setSectionOpen(header, !isOpen);
            });
        });

        // Initialize existing carousels
        if (document.querySelector('.farlo-ui-revolver-carousel')) {
            document.querySelectorAll('.farlo-ui-revolver-carousel').forEach(_sel => {
                new Flickity(_sel, {});
            });
        }

        if (document.querySelector('.secondary-revolver-carousel')) {
            document.querySelectorAll('.secondary-revolver-carousel').forEach(_sel => {
                new secondaryFlickity(_sel);
            });
        }

        if (document.querySelector("#event-key-info__toggle")) {
            document.querySelector("#event-key-info__toggle").addEventListener("click", () => {
                document.body.classList.toggle("event-key-info--open");
            });
        }
    });

    // Outside DOMContentLoaded
    if (document.querySelector('.farlo-ui-map')) mapLoader();

    if (typeof navigator !== 'undefined') {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(reg => reg.unregister());
        });
    }

    Flickity.prototype._touchActionValue = 'pan-y pinch-zoom';

    window.toggleFullscreen = (selector, startIdx = 0) => {
        const carousel = document.querySelector(selector);
        if (!carousel) return;
        const flkty = Flickity.data(carousel);
        if (!flkty) return;
        const oldNav = carousel.parentElement.querySelector('.flickity-nav-wrapper');
        if (oldNav) oldNav.remove();

        flkty.options.pageDots = false;
        flkty.options.prevNextButtons = true;
        carousel.parentElement.style.display = 'block';

        flkty.once('fullscreenChange', isFS => {
            if (!isFS) return;
            const fsRoot = carousel.parentElement;
            const prevBtn = fsRoot.querySelector('.flickity-prev-next-button.previous');
            const nextBtn = fsRoot.querySelector('.flickity-prev-next-button.next');
            if (prevBtn && nextBtn) {
                const wrapper = document.createElement('div');
                wrapper.className = 'flickity-nav-wrapper';
                prevBtn.parentNode.insertBefore(wrapper, prevBtn);
                wrapper.appendChild(prevBtn);

                const navContainer = document.createElement('div');
                const slideCount = flkty.slides.length;
                navContainer.className = 'dot-nav';
                for (let i = 0; i < slideCount; i++) {
                    const cell = document.createElement('div');
                    cell.className = 'dot-cell';
                    navContainer.appendChild(cell);
                }
                wrapper.appendChild(navContainer);
                wrapper.appendChild(nextBtn);
                new Flickity(navContainer, {
                    asNavFor: selector,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    draggable: false,
                    wrapAround: false,
                    cellAlign: 'left',
                });
            }

            flkty.on('staticClick', (event, pointer) => {
                const target = pointer.target;
                if (target.classList.contains('has-media-video')) {
                    const match = target.dataset.video.match(youTubeRegex);
                    if (!match) return;
                    const iframe = document.createElement('iframe');
                    iframe.className = 'farlo-ui-lightbox__inner-content-iframe';
                    iframe.src = `https://www.youtube-nocookie.com/embed/${match[1]}?autoplay=1&rel=0`;
                    iframe.frameBorder = '0';
                    iframe.allow = 'autoplay; encrypted-media';
                    iframe.allowFullscreen = true;
                    const videoWrapper = document.createElement('div');
                    videoWrapper.className = 'has-media-video__active';
                    videoWrapper.appendChild(iframe);
                    target.appendChild(videoWrapper);
                }
            });

            const isTouch = ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
            if (!isTouch) return;

            fsRoot.querySelectorAll('.flickity-viewport img').forEach(img => {
                img.style.objectFit = 'contain';
                img.style.maxWidth = '100%';
                img.style.maxHeight = '100%';
                img.parentElement.style.overflow = 'visible';
                const panzoom = Panzoom(img, {
                    maxScale: 10,
                    minScale: 1,
                    contain: false,
                    pinchAndPan: true,
                    panOnlyWhenZoomed: true,
                    duration: 0,
                    touchAction: 'none'
                });
                img.addEventListener('panzoomstart', () => {
                    flkty.unbindDrag();
                    fsRoot.classList.add('is-zooming');
                });
                img.addEventListener('touchmove', e => {
                    if (panzoom.getScale() > 1) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }, { passive: false });
                img.addEventListener('panzoomend', () => {
                    panzoom.setOptions({ duration: 300 });
                    panzoom.reset();
                    setTimeout(() => panzoom.setOptions({ duration: 0 }), 300);

                    fsRoot.classList.remove('is-zooming');
                });
            });
        });
        flkty.toggleFullscreen();
        if (typeof startIdx === 'number') flkty.select(startIdx);

        const exitBtn = carousel.parentElement.querySelector('.flickity-fullscreen-button-exit');
        if (exitBtn) {
            exitBtn.addEventListener('click', () => {
                carousel.parentElement.style.display = 'none';
                const nav = carousel.parentElement.querySelector('.flickity-nav-wrapper');
                if (nav) nav.remove();
            });
        }
    };

    const starLogo = document.querySelector(".site-footer__partners a[href='https://star.org.uk']");
    if (starLogo) {
        starLogo.addEventListener("click", e => {
            e.preventDefault();
            window.open("https://www.star.org.uk/verify?dn=https://nimaxtheatres.com", "_blank", "toolbar=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,width=560,height=490");
        });
    }

    window.addEventListener("load", () => {
        document.body.classList.add("loaded");
        if (document.querySelector('#particles-js')) particles();
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
        document.body.classList.add("resize-animation-stopper");
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove("resize-animation-stopper");
        }, 400);
    });
})(document, window, history);
